import axios, { AxiosResponse } from 'axios';
import { setupInterceptorsTo } from '@/shared/services/httpInterceptors';

import { SendEVDRequest, ExecuteExportRequest, GetEVDDocCompRequest, NeadsubKennzeichenRequest } from '../models/Zelos/ZelosModels';
import { CreateApiKeyRequest } from '../models/ApiKeyModels';
import { CreateArchivApiKeyEinstellungRequest } from '../models/EinstellungModels';

/* DEV */
// import config from '../../../../appsettings.dev.json';

/* PROD */
const appsettings = await fetch('/appsettings.json');
const config = await appsettings.json();

const env = window.__ENV__ ?? null;
const BASE_URL = (env != undefined && env?.ZELOS_BASE_URL != undefined && env?.ZELOS_BASE_URL != '' ? env?.ZELOS_BASE_URL : config.zelosapi.baseUrl) + '/v1';

// Get Tenant from URL (e.g. https://tenant.example.com -> tenant), if no subdomain is present, use default tenant from config
const tenantFromUrl = window.location.hostname.split('.')[0];
const tenant =
  tenantFromUrl !== undefined && tenantFromUrl !== 'www' && tenantFromUrl !== 'localhost' && tenantFromUrl !== '' && tenantFromUrl != 'zelos'
    ? tenantFromUrl
    : env != undefined && env?.AUTH_DEFAULT_REALM != undefined && env?.AUTH_DEFAULT_REALM != ''
      ? env?.AUTH_DEFAULT_REALM
      : config.auth.defaultRealm;

const apiClient = setupInterceptorsTo(
  axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      tenant: tenant,
    },
  })
);

export default {
  //#region  ApiKeys
  getAllApiKeys(): Promise<AxiosResponse> {
    return apiClient.get('/apikeys');
  },

  createApiKey(data: CreateApiKeyRequest): Promise<AxiosResponse> {
    return apiClient.post('/apikey', data);
  },

  deleteApiKey(id: number): Promise<AxiosResponse> {
    return apiClient.delete(`/apikey/${id}`);
  },
  //#endregion

  //#region Einstellungen
  hasEinstellungArchivApiKeySet(): Promise<AxiosResponse> {
    return apiClient.get('/einstellung/archivapikey');
  },

  upsertEinstellungArchivApiKey(data: CreateArchivApiKeyEinstellungRequest): Promise<AxiosResponse> {
    return apiClient.post('/einstellung/archivapikey', data);
  },
  //#endregion

  //#region NEadSub
  getAllEntwurfeDatum(datum: string): Promise<AxiosResponse> {
    return apiClient.get(`/neadsub?datum=${datum}`);
  },

  getNeadsubByEaddraftlocalrefnr(eaddraftlocalrefnr: string): Promise<AxiosResponse> {
    return apiClient.get(`/neadsub/eaddraftlocalrefnr/${eaddraftlocalrefnr}`);
  },

  getEVDDocComp(data: GetEVDDocCompRequest): Promise<AxiosResponse> {
    return apiClient.get(`/neadsub/doc?eaddraftLocalrefnr=${data.eaddraftLocalrefnr}`, { responseType: 'blob' });
  },

  sendBezugsnummer(data: SendEVDRequest): Promise<AxiosResponse> {
    return apiClient.get(`/neadsub/eaddraftlocalrefnr?headermessagesender=${data.headermessagesender}&eaddraftLocalrefnr=${data.eaddraftLocalrefnr}`);
  },

  executeExport(data: ExecuteExportRequest): Promise<AxiosResponse> {
    return apiClient.post('/export', data);
  },

  neadsubEditKennzeichen(data: NeadsubKennzeichenRequest): Promise<AxiosResponse> {
    return apiClient.put('/neadsub/kennzeichen', data);
  },
  //#endregion

  //#region NEadSubPos
  getNEadSubPosByNEadSubId(id: number): Promise<AxiosResponse> {
    return apiClient.get(`/neadsubpos/neadsubid/${id}`);
  },
  //#endregion

  //#region CEadVal
  getCEadValDatum(datum: string): Promise<AxiosResponse> {
    return apiClient.get(`/ceadval?datum=${datum}`);
  },
  //#endregion

  //#region  CEAdValPos
  getCEadValPosByCEadValId(id: number): Promise<AxiosResponse> {
    return apiClient.get(`/ceadvalpos/ceadvalid/${id}`);
  },
  //#endregion
};
